import { Clock, DollarSign, Users, Code, Zap } from 'lucide-react';
import Card from '@/components/common/ui/Card';

const plans = [
    {
        icon: DollarSign,
        title: "Competitive Salary",
        description: "Industry-leading compensation packages with regular reviews and performance bonuses."
    },
    {
        icon: Users,
        title: "Health & Wellness",
        description: "Comprehensive health insurance, dental, vision, and mental health support programs."
    },
    {
        icon: Clock,
        title: "Flexible Working",
        description: "Remote work options, flexible hours, and unlimited PTO to maintain work-life balance."
    },
    {
        icon: Code,
        title: "Learning & Development",
        description: "Professional development budget, conference attendance, and online course subscriptions."
    },
    {
        icon: Zap,
        title: "Latest Technology",
        description: "Work with cutting-edge tools and technologies. Choose your own equipment setup."
    },
    {
        icon: Users,
        title: "Team Culture",
        description: "Collaborative environment with regular team events, hackathons, and social activities."
    }
];

export default function OtherServices() {
    return (
        <section className="container pb-24 pt-24">
            <div className="text-center  mb-12">
                <h3 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-3">
                    Why Join SAN micron?
                </h3>
                <p className="text-gray-300 max-w-2xl mx-auto">
                    We offer more than just a job. Join a culture of innovation, collaboration, and continuous growth.
                </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
                {plans.map((plan, index) => (
                    <Card
                        key={index}
                        title={plan.title}
                        description={plan.description}
                        icon={plan.icon}
                    />
                ))}
            </div>
        </section>
    );
}